import { createRoot } from 'react-dom/client'
// Axios
import { QueryClient, QueryClientProvider } from 'react-query'

// Apps
import AppContext from './Context/AppContext'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import 'nouislider/dist/nouislider.css'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider } from 'Presentation/Views/Auth'
import { ThemeModeProvider } from './_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { setupAxios } from 'Configuration/Axios/Interceptor'

// Libraries Styles
import 'react-tooltip/dist/react-tooltip.css'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

// Kumopack Styles and Customized Components Styles
import './Styles/main.scss'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'yet-another-react-lightbox/styles.css'
import 'leaflet/dist/leaflet.css'

// Firebase
import { initializeApp } from 'firebase/app'

// i18n
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import EnTranslation from 'Locales/en.json'
import ThTranslation from 'Locales/th.json'

import axios from 'axios'
setupAxios(axios)

i18n.use(initReactI18next).init({
	resources: {
		en: {
			translation: EnTranslation,
		},
		th: {
			translation: ThTranslation,
		},
	},
	lng: 'th',
	fallbackLng: 'th',
	interpolation: {
		escapeValue: false,
	},
})

const firebaseConfig = {
	apiKey: 'AIzaSyDoLL5aJhy0UPGGjoSlJGCrHuunxHPDCio',
	authDomain: 'kumopack-ui.firebaseapp.com',
	projectId: 'kumopack-ui',
	storageBucket: 'kumopack-ui.appspot.com',
	messagingSenderId: '1093254020486',
	appId: '1:1093254020486:web:83d99a27f13d3b9a270007',
}

// Initialize Firebase
initializeApp(firebaseConfig)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
	createRoot(container).render(
		<QueryClientProvider client={queryClient}>
			<MetronicI18nProvider>
				<ThemeModeProvider>
					<AuthProvider>
						<AppContext>
							<AppRoutes />
							<ToastContainer />
						</AppContext>
					</AuthProvider>
				</ThemeModeProvider>
			</MetronicI18nProvider>
		</QueryClientProvider>
	)
}
